import { Module } from 'vuex'
import { RootState } from '@/store/types'
import {Metadata, SEOCompletor, AnalysisReport} from '@/modules/seo/types'
import mutations from '@/modules/seo/store/mutations'
import getters from '@/modules/seo/store/getters'
import actions from '@/modules/seo/store/actions'

export interface SEOState {

    /**
     * El conjunto de meta-datos SEO actualmente en edición o visualización en el
     * componente de edición
     */
    currentMetadata: Metadata

    /**
     * Idioma de la traducción que se encuentra actualmente en edición
     */
    currentLocale: string,

    /**
     * Función encargada de auto-completar el seo
     */
    seoCompletor: SEOCompletor | null,

    /**
     * Campos de los meta-datos SEO modificados por el usuario
     */
    touchedMetadataFields: Map<string, string[]>,

    /**
     * Reporte de análisis SEO actualmente mostrado al usuario
     */
    currentAnalysisReport: AnalysisReport,

    /**
     * Indica si el proceso de análisis SEO se encuentra en proceso
     */
    processingSEOAnalysis: boolean,
}

const vuexModule: Module<SEOState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    getters,
    state: {
        currentMetadata: new Metadata(),
        currentLocale: '',
        seoCompletor: null,
        touchedMetadataFields: new Map(),
        currentAnalysisReport: new AnalysisReport(),
        processingSEOAnalysis: false,
    },
}

export default vuexModule
